import React from 'react';
import { Link } from 'veloe-ds';
import PropTypes from 'prop-types';
import { ExternalLink } from './styles';

const CustomLink = React.forwardRef(({ to, children, ...props }, ref) => {
  const external = to.startsWith('http') === true;
  return (
    <>
      {external ? (
        <ExternalLink {...props} ref={ref} href={to}>
          {children}
        </ExternalLink>
      ) : (
        <Link href={to}>
          <ExternalLink
            {...props}
            ref={ref}
            tabIndex={props.tabIndex}
            role="link"
            href={to}
          >
            {children}
          </ExternalLink>
        </Link>
      )}
    </>
  );
});

CustomLink.propTypes = {
  children: PropTypes.any,
  external: PropTypes.bool,
  to: PropTypes.string,
  parentComponent: PropTypes.string,
  tabIndex: PropTypes.number,
  tagLabel: PropTypes.string,
};

CustomLink.defaultProps = {
  children: undefined,
  external: false,
  to: undefined,
  parentComponent: 'footer',
  tabIndex: 0,
  tagLabel: undefined,
};

CustomLink.displayName = 'CustomLink';

export default CustomLink;
